import React, {Component} from "react";

/**
 * Get a date object
 *
 * @param {React} props
 * @returns HTML <time> object with date and time string.
 */
function DateTimeDisplay(props) {
  const {
    date,
    hide_time
  } = props;

  return <time dateTime={date.toISOString()} className="submittedDateTime" title={""+date}>
          {date.toLocaleDateString()} {hide_time ? "" : date.toLocaleTimeString()}
    </time>
}

export {DateTimeDisplay};
